import { User } from '../types';

/**
 * Returns true when the given user must accept Terms of Service before proceeding.
 * Superadmins are exempt; all other roles must accept.
 */
export function needsTermsConsent(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.is_superadmin || user.user_type === 'superadmin') return false;
  return !user.terms_accepted_at;
}

/**
 * Resolve where to send the user after terms are accepted.
 * Avoids redirect loops back to /accept-terms.
 */
export function resolvePostTermsRedirectPath(from: unknown): string {
  if (typeof from === 'string') {
    return from === '/accept-terms' ? '/dashboard' : from;
  }

  if (from && typeof from === 'object' && 'pathname' in from) {
    const pathname = String((from as { pathname?: string }).pathname || '/dashboard');
    return pathname === '/accept-terms' ? '/dashboard' : pathname;
  }

  return '/dashboard';
}
